import { apiDelete, apiPost, apiPut } from '../../framework/client';
import { PartPaymentRow } from '../../../common/application/model/PartPaymentRow';
import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';
import { GeneratePartPaymentRowsReq } from '../../../common/application/model/api/GeneratePartPaymentRowsReq';

export async function createPartPaymentRows(partPaymentRows: PartPaymentRow[]): Promise<PartPaymentRow[]> {
    const response = await apiPost('/api/create-part-payment-rows', partPaymentRows);
    if (response.status === 200) {
        return await response.json();
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function updatePartPaymentRow(partPaymentRow: PartPaymentRow): Promise<PartPaymentRow> {
    const response = await apiPut('/api/update-part-payment-row', partPaymentRow);
    if (response.status === 200) {
        return await response.json();
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function deletePartPaymentRows(vehicleContractId: string): Promise<boolean> {
    const response = await apiDelete(`/api/delete-part-payment-rows/${vehicleContractId}`);
    if (response.status === 200) {
        return await response.json();
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function generatePartPaymentFromFile(request: GeneratePartPaymentRowsReq): Promise<PartPaymentRow[]> {
    const response = await apiPost('/api/generate-part-payment-rows', request);
    if (response.status === 200) {
        return await response.json();
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}
